var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"slider-demo"}},[_c('slider-default'),_c('slider-color'),_c('slider-ticks'),_c('slider-range'),_c('slider-icon'),_c('slider-text-fixed'),_c('slider-change-method')],1)}
var staticRenderFns = []

export { render, staticRenderFns }